<div class="content-card" [ngClass]="['image-position-' + (cardData.imagePosition ?? '999'), 'theme-' + cardData.theme]" *ngIf="cardData">
  <div class="card-time" brtRoughText [type]="'circle'" [state]="current ? 'run' : 'stop'" *ngIf="cardData.time.length">{{cardData.time}} Uhr</div>
  <div class="content-card__title">
    <span [innerHTML]="cardData.title"></span>
  </div>
  <div class="content-card__text" [innerHTML]="cardData.text"></div>

  <div class="content-card__image" *ngIf="cardData.image"><brt-image [image]="cardData.image"></brt-image></div>
</div>
